import { handleActions } from "redux-actions";

export default handleActions(
  {
    COMPANY_PUBLIC_GET: {
      FULFILLED: (state, action) => ({
        company: action.payload.company,
      }),
    },

    COMPANY_FOR_TOOLTIP_PUBLIC_GET: {
      FULFILLED: (_state, action) => ({
        companies: [..._state.companies, action.payload.company],
      }),
    },
  },
  {},
  { namespace: "_" }
);
